<section class="page-head">
  <div>
    <h1>{{ 'admin.users_title' | translate }}</h1>
    <p>{{ (isPlatformAdmin ? 'admin.users_subtitle_platform' : 'admin.users_subtitle') | translate }}</p>
  </div>
  <button type="button" class="dm-a-btn primary" (click)="openCreate()">
    <i-tabler name="user-plus" class="icon-18"></i-tabler>{{ 'admin.invite_user' | translate }}
  </button>
</section>

<section class="toolbar">
  <label class="search">
    <i-tabler name="search" class="icon-18"></i-tabler>
    <input type="search" [(ngModel)]="search" [placeholder]="'admin.search_users' | translate"
           [attr.aria-label]="'admin.search_users' | translate"/>
  </label>
  @if (isPlatformAdmin) {
    <mat-form-field appearance="outline" class="company-filter" subscriptSizing="dynamic">
      <mat-label>{{ 'admin.company' | translate }}</mat-label>
      <mat-select [(ngModel)]="companyFilter" (selectionChange)="onCompanyFilter()">
        <mat-option [value]="0">{{ 'admin.all_companies' | translate }}</mat-option>
        @for (company of companies; track company.id) {
          <mat-option [value]="company.id">{{ company.name }}</mat-option>
        }
      </mat-select>
    </mat-form-field>
  }
</section>

@if (error) {
  <p class="dm-a-error" role="alert">{{ error }}</p>
}

<div class="card">
  @if (loading) {
    <div class="state"><mat-spinner diameter="32"></mat-spinner></div>
  } @else if (visibleAccounts.length === 0) {
    <div class="state">
      <i-tabler name="users" class="icon-32"></i-tabler>
      <p>{{ (search ? 'admin.no_results' : 'admin.no_users') | translate }}</p>
    </div>
  } @else {
    <table class="data-table">
      <thead>
        <tr>
          <th>{{ 'admin.user' | translate }}</th>
          <th>{{ 'admin.role' | translate }}</th>
          @if (isPlatformAdmin) {
            <th class="hide-md">{{ 'admin.company' | translate }}</th>
          }
          <th>{{ 'admin.status' | translate }}</th>
          <th class="actions-col"><span class="sr-only">{{ 'admin.actions' | translate }}</span></th>
        </tr>
      </thead>
      <tbody>
        @for (account of visibleAccounts; track account.id) {
          <tr>
            <td>
              <div class="person">
                <span class="initials">{{ displayName(account).slice(0, 1).toUpperCase() }}</span>
                <span class="person-text">
                  <strong>{{ displayName(account) }}
                    @if (isSelf(account)) {
                      <em class="you">{{ 'admin.you' | translate }}</em>
                    }
                  </strong>
                  <span>{{ account.email }}</span>
                </span>
              </div>
            </td>
            <td>{{ 'admin.role_' + account.role | translate }}</td>
            @if (isPlatformAdmin) {
              <td class="hide-md">{{ account.company_name }}</td>
            }
            <td><span class="dm-a-badge {{ account.status }}">{{ 'admin.status_' + account.status | translate }}</span></td>
            <td class="actions-col">
              <button type="button" class="icon-btn" [matMenuTriggerFor]="menu" [attr.aria-label]="'admin.actions' | translate">
                <i-tabler name="dots-vertical" class="icon-18"></i-tabler>
              </button>
              <mat-menu #menu="matMenu" xPosition="before">
                <button mat-menu-item (click)="openEdit(account)">
                  <i-tabler name="pencil" class="icon-18 m-r-8"></i-tabler>{{ 'admin.edit' | translate }}
                </button>
                @if (account.status === 'invited') {
                  <button mat-menu-item (click)="resendInvite(account)">
                    <i-tabler name="mail-forward" class="icon-18 m-r-8"></i-tabler>{{ 'admin.resend_invite' | translate }}
                  </button>
                }
                @if (account.status === 'active' && !isSelf(account)) {
                  <button mat-menu-item (click)="setActive(account, false)">
                    <i-tabler name="user-off" class="icon-18 m-r-8"></i-tabler>{{ 'admin.deactivate' | translate }}
                  </button>
                }
                @if (account.status === 'disabled') {
                  <button mat-menu-item (click)="setActive(account, true)">
                    <i-tabler name="user-check" class="icon-18 m-r-8"></i-tabler>{{ 'admin.activate' | translate }}
                  </button>
                }
              </mat-menu>
            </td>
          </tr>
        }
      </tbody>
    </table>
  }
</div>
